<script>
const httpUrl = process.env.VUE_APP_BASE_URL //由 .env.development / .env.production 按构建模式自动注入

export default {
    httpUrl
}
</script>
